import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { HelperService } from "../../services/helper.service";
import { MapDesignationService } from "../../services/mapdesignation.service";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DashboardService } from "../../services/dashboard.service";

import { DesignationMasterService } from "../../services/designation-master.service";
import { AssessmentService } from "../../services/assessment.service";
import { ObjectivesService } from "../../services/objectives.service";

@Component({
  selector: "app-objectives-edit-modal-desig",
  templateUrl: "./objectives-edit-modal-desig.html",
  providers: [ObjectivesService, DashboardService],
})


export class AddMapDesigModalComponent implements OnInit {

  @Input() header_id: number;
  @Output() dataToEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  companySystemID = +this.helperService.getSelectedCompanyId();
  Designations: any = [];


  public designationData = [];
  public designationSettings = {};

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private objectivesService: ObjectivesService,
    private assessmentService: AssessmentService,
    private designationMasterService: DesignationMasterService,
    private dashboardService: DashboardService,
  ) {

    this.formData.designationSelectedItems = [];

    this.designationSettings = {
      singleSelection: false,
      text: "Select Designations",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      enableSearchFilter: true,
      badgeShowLimit: 1,
      classes: "myclass custom-class",
    };
  }

  public formData: any = {};



  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }



  public getwidgetDropdown() {
    this.spinner.show();
    const companySystemID = +this.helperService.getSelectedCompanyId();
    // //console.log(companySystemID);
    const that = this;
    let resp;
    this.dashboardService
      .getwidgetDropdown()
      // .get()
      .get({ companySystemID: companySystemID }) 
      .subscribe((data) => {
        const resp = data.data.data;
        //console.log(resp);
        that.designationData = that.helperService.setMultipleselectDropDown(resp.allDesignation, "id", "designationCategory");
        that.formData.designationSelectedItems = that.helperService.setMultipleselectDropDown(resp.allDesignation, "id", "designationCategory");
        that.formData.designationSelectedItems = [];
        this.spinner.hide();
      }, (error) => {
      });
  }

















  ngOnInit() {

    this.header_id = Number(localStorage.getItem("objective-sedit_auto_id"));
    localStorage.removeItem("objective-sedit_auto_id");

    setTimeout(() => {
      this.getwidgetDropdown();
      $(".breadcrumb").addClass("hide");
    }, 400);
  }



  addMapDesig() {

    // const designation = formData.designation;
    // const designationArray = Array.isArray(designation) ? designation : [designation];

    const requestData = {
      // "designation": designationArray,
      designation_id: this.formData.designationSelectedItems,
      company_id: this.companySystemID,
      header_id: this.header_id,
    };
    //console.log(requestData);
    let that = this;
    that.objectivesService.addMapDesig()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          //console.log(resp);
          that.successMsg = "Successfully added a new map designation.";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
  }


  // designationCategories: any;

  // public getFormData() {
  //   const that = this;
  //   this.designationMasterService
  //     .getTemplateEmployeesFormData()
  //     .get({
  //       companySystemID: +that.helperService.getSelectedCompanyId(),
  //       type: "create",
  //     })
  //     .subscribe(
  //       (data) => {
  //         const resp = data.data.data;
  //         that.designationCategories = that.helperService.setSelect2DropDownOptions(
  //           resp.designationCategories,
  //           "id",
  //           "designationCategory"
  //         );
  //       },
  //       (error) => { }
  //     );
  // }



  // retrieveDesignations(): void {
  //   this.Designations = [];
  //   let dataTablesParameters: any = {
  //     companyId: this.helperService.getSelectedCompanyId(),
  //   };
  //   this.assessmentService
  //     .retrieveDesignations()
  //     .customPOST(dataTablesParameters)
  //     .subscribe(
  //       (resp: any) => {
  //         let data = JSON.parse(resp._body);
  //         this.Designations = data.data;
  //         //console.log(this.Designations);
  //       },
  //       (err: any) => {
  //         //console.log(err);
  //       }
  //     );
  // }

  // selectedDesignation: string;
  // onDesignationChange(event) {
  //   this.selectedDesignation = event.target.value.split('-')[1];
  // }


}



// WEBPACK FOOTER //
// /app/src/app/competancy/objectives-edit-modal-desig/objectives-edit-modal-desig.ts